import { default as _91_46_46_46slug_93nL1j908z18Meta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93wGNwcvSUYtMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/get-a-quote/[...slug].vue?macro=true";
import { default as indexjNhF8G7VieMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/get-a-quote/heat-pump/index.vue?macro=true";
import { default as index7zdtn1NwN7Meta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/get-a-quote/solar/index.vue?macro=true";
import { default as homepage_45preview_45v1ZN2AVtIMF4Meta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/homepage-preview-v1.vue?macro=true";
import { default as indexqdDiNOY3k6Meta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_932W8KvLPU0bMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/[...slug].vue?macro=true";
import { default as homepage_45preview_45v1TWwNaIXERKMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/homepage-preview-v1.vue?macro=true";
import { default as solar_45battery_45campaign_45preview_45v2HZ6fp68CGxMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/solar-battery-campaign-preview-v2.vue?macro=true";
import { default as solar_45battery_45campaign_45preview_45v36ir2fGVJDvMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/solar-battery-campaign-preview-v3.vue?macro=true";
import { default as solar_45battery_45campaignA5eUJ6kkpiMeta } from "/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/solar-battery-campaign.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93nL1j908z18Meta?.name ?? "slug",
    path: _91_46_46_46slug_93nL1j908z18Meta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93nL1j908z18Meta || {},
    alias: _91_46_46_46slug_93nL1j908z18Meta?.alias || [],
    redirect: _91_46_46_46slug_93nL1j908z18Meta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93wGNwcvSUYtMeta?.name ?? "get-a-quote-slug",
    path: _91_46_46_46slug_93wGNwcvSUYtMeta?.path ?? "/get-a-quote/:slug(.*)*",
    meta: _91_46_46_46slug_93wGNwcvSUYtMeta || {},
    alias: _91_46_46_46slug_93wGNwcvSUYtMeta?.alias || [],
    redirect: _91_46_46_46slug_93wGNwcvSUYtMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/get-a-quote/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexjNhF8G7VieMeta?.name ?? "get-a-quote-heat-pump",
    path: indexjNhF8G7VieMeta?.path ?? "/get-a-quote/heat-pump",
    meta: indexjNhF8G7VieMeta || {},
    alias: indexjNhF8G7VieMeta?.alias || [],
    redirect: indexjNhF8G7VieMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/get-a-quote/heat-pump/index.vue").then(m => m.default || m)
  },
  {
    name: index7zdtn1NwN7Meta?.name ?? "get-a-quote-solar",
    path: index7zdtn1NwN7Meta?.path ?? "/get-a-quote/solar",
    meta: index7zdtn1NwN7Meta || {},
    alias: index7zdtn1NwN7Meta?.alias || [],
    redirect: index7zdtn1NwN7Meta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/get-a-quote/solar/index.vue").then(m => m.default || m)
  },
  {
    name: homepage_45preview_45v1ZN2AVtIMF4Meta?.name ?? "homepage-preview-v1",
    path: homepage_45preview_45v1ZN2AVtIMF4Meta?.path ?? "/homepage-preview-v1",
    meta: homepage_45preview_45v1ZN2AVtIMF4Meta || {},
    alias: homepage_45preview_45v1ZN2AVtIMF4Meta?.alias || [],
    redirect: homepage_45preview_45v1ZN2AVtIMF4Meta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/homepage-preview-v1.vue").then(m => m.default || m)
  },
  {
    name: indexqdDiNOY3k6Meta?.name ?? "index",
    path: indexqdDiNOY3k6Meta?.path ?? "/",
    meta: indexqdDiNOY3k6Meta || {},
    alias: indexqdDiNOY3k6Meta?.alias || [],
    redirect: indexqdDiNOY3k6Meta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_932W8KvLPU0bMeta?.name ?? "landing-slug",
    path: _91_46_46_46slug_932W8KvLPU0bMeta?.path ?? "/landing/:slug(.*)*",
    meta: _91_46_46_46slug_932W8KvLPU0bMeta || {},
    alias: _91_46_46_46slug_932W8KvLPU0bMeta?.alias || [],
    redirect: _91_46_46_46slug_932W8KvLPU0bMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/[...slug].vue").then(m => m.default || m)
  },
  {
    name: homepage_45preview_45v1TWwNaIXERKMeta?.name ?? "landing-homepage-preview-v1",
    path: homepage_45preview_45v1TWwNaIXERKMeta?.path ?? "/landing/homepage-preview-v1",
    meta: homepage_45preview_45v1TWwNaIXERKMeta || {},
    alias: homepage_45preview_45v1TWwNaIXERKMeta?.alias || [],
    redirect: homepage_45preview_45v1TWwNaIXERKMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/homepage-preview-v1.vue").then(m => m.default || m)
  },
  {
    name: solar_45battery_45campaign_45preview_45v2HZ6fp68CGxMeta?.name ?? "landing-solar-battery-campaign-preview-v2",
    path: solar_45battery_45campaign_45preview_45v2HZ6fp68CGxMeta?.path ?? "/landing/solar-battery-campaign-preview-v2",
    meta: solar_45battery_45campaign_45preview_45v2HZ6fp68CGxMeta || {},
    alias: solar_45battery_45campaign_45preview_45v2HZ6fp68CGxMeta?.alias || [],
    redirect: solar_45battery_45campaign_45preview_45v2HZ6fp68CGxMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/solar-battery-campaign-preview-v2.vue").then(m => m.default || m)
  },
  {
    name: solar_45battery_45campaign_45preview_45v36ir2fGVJDvMeta?.name ?? "landing-solar-battery-campaign-preview-v3",
    path: solar_45battery_45campaign_45preview_45v36ir2fGVJDvMeta?.path ?? "/landing/solar-battery-campaign-preview-v3",
    meta: solar_45battery_45campaign_45preview_45v36ir2fGVJDvMeta || {},
    alias: solar_45battery_45campaign_45preview_45v36ir2fGVJDvMeta?.alias || [],
    redirect: solar_45battery_45campaign_45preview_45v36ir2fGVJDvMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/solar-battery-campaign-preview-v3.vue").then(m => m.default || m)
  },
  {
    name: solar_45battery_45campaignA5eUJ6kkpiMeta?.name ?? "landing-solar-battery-campaign",
    path: solar_45battery_45campaignA5eUJ6kkpiMeta?.path ?? "/landing/solar-battery-campaign",
    meta: solar_45battery_45campaignA5eUJ6kkpiMeta || {},
    alias: solar_45battery_45campaignA5eUJ6kkpiMeta?.alias || [],
    redirect: solar_45battery_45campaignA5eUJ6kkpiMeta?.redirect,
    component: () => import("/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/pages/landing/solar-battery-campaign.vue").then(m => m.default || m)
  }
]